import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  setName as setLayoutName
} from '../redux/layouts'

export default function * requestChangeLayoutName (action) {
  const { id, name } = action.payload

  const optimisticAction = yield optimisticPut(setLayoutName({
    id,
    name
  }))

  try {
    yield call(apiAction, 'RenameHomeLayout', {
      id,
      name
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
